import { Grid, Bones } from '@simplywallst/ui-core';
import { Snowflake } from '@simplywallst/ui-charts/Snowflake';

import { FeedCardItemSkeleton } from '@/components/FeedCard';

import { Tile } from '../../../Tile';

import { StyledCompanyFeed } from './styled';

export const OverviewSkeleton = () => {
  return (
    <Grid gap="8px">
      <Tile templateRows="repeat(2, max-content)" gap="16px">
        <Grid
          templateColumns="repeat(2, auto)"
          templateRows="21px"
          justifyContent="space-between"
          alignItems="center"
        >
          <Bones minWidth="100px" />
          <Bones minWidth="50px" />
        </Grid>
        <StyledCompanyFeed>
          <FeedCardItemSkeleton />
        </StyledCompanyFeed>
      </Tile>
      <Tile templateRows="repeat(2, max-content)" gap="16px">
        <Grid
          templateColumns="repeat(2, auto)"
          templateRows="21px"
          justifyContent="space-between"
          alignItems="center"
        >
          <Bones minWidth="70px" />
          <Bones minWidth="40px" />
        </Grid>
        <Bones maxWidth="100%" minHeight="40px" />
      </Tile>
      <Tile rowGap="16px">
        <Grid templateColumns="1fr max-content" gap="12px">
          <Grid templateRows="repeat(2, max-content)" gap="16px">
            <Grid templateRows="auto auto auto" gap="8px">
              <Bones maxWidth="80px" />
              <Grid gap="2px">
                <Bones maxWidth="120px" />
                <Bones maxWidth="120px" />
              </Grid>
            </Grid>
            <Grid templateRows="auto auto" gap="2px">
              <Bones maxWidth="60px" />
              <Bones maxWidth="70px" />
            </Grid>
          </Grid>
          <Grid templateColumns="132px 16px">
            <Snowflake width={132} points={[0, 0, 0, 0, 0]}>
              <Snowflake.Labels />
            </Snowflake>
            <Bones borderRadius="x2" maxWidth="16px" maxHeight="16px" />
          </Grid>
        </Grid>
        <Grid templateColumns="repeat(4, 1fr)">
          <Grid gap="2px">
            <Bones maxWidth="30px" />
            <Bones maxWidth="60px" />
          </Grid>
          <Grid gap="2px">
            <Bones maxWidth="30px" />
            <Bones maxWidth="60px" />
          </Grid>
          <Grid gap="2px">
            <Bones maxWidth="30px" />
            <Bones maxWidth="60px" />
          </Grid>
          <Grid gap="2px">
            <Bones maxWidth="30px" />
            <Bones maxWidth="60px" />
          </Grid>
        </Grid>
        <Grid gap="2px">
          <Bones maxWidth="130px" />
          <Bones maxWidth="230px" />
        </Grid>
      </Tile>
      <Tile gap="16px">
        <Grid
          templateColumns="max-content 16px"
          templateRows="21px"
          justifyContent="space-between"
          alignItems="center"
        >
          <Bones minWidth="50px" />
          <Bones borderRadius="x2" maxWidth="16px" />
        </Grid>
        <Grid rowGap="8px">
          <Bones maxWidth="250px" />
          <Bones maxWidth="250px" />
        </Grid>
        <Grid rowGap="8px">
          <Bones maxWidth="50px" />
          <Bones maxWidth="250px" />
          <Bones maxWidth="250px" />
        </Grid>
      </Tile>
    </Grid>
  );
};
